const Address = () =>
  import(/* webpackChunkName: "transport-address" */ '@/pages/user/address')

const CreateAddress = () =>
  import(
    /* webpackChunkName: "transport-address" */ '@/pages/user/address/create.vue'
  )
const EditAddress = () =>
  import(
    /* webpackChunkName: "transport-address" */ '@/pages/user/address/edit.vue'
  )
const DetailAddress = () =>
  import(
    /* webpackChunkName: "transport-address" */ '@/pages/user/address/detail.vue'
  )

export default {
  path: 'address',
  meta: {
    label: 'address',
    auth: 'address'
  },
  component: {
    name: 'Address',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'UserAddressReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Address
    },
    {
      name: 'UserCreateAddress',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateAddress
    },
    {
      name: 'UserEditAddress',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditAddress,
      props: true
    },
    {
      name: 'UserDetailAddress',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'report'
      },
      component: DetailAddress,
      props: true
    }
  ]
}
